import {LO99_LIST_RECENT_DRAW} from "./types";

const init = {
    list: [],
    listFull: [],
}


export default (state = init, {type, payload}) => {
    switch (type) {
        case LO99_LIST_RECENT_DRAW:
            return {
                ...state,
                list: payload.slice(0, 6),
                listFull: payload
            };
        default:
            return state;
    }
}
